import ColumnConfig from "./columnConfig";

function deserializeColumnConfig(columnConfigData) {
  if (!columnConfigData) return new ColumnConfig();

  const width =
    typeof columnConfigData.width === "number"
      ? columnConfigData.width
      : typeof columnConfigData.columnWidth === "number"
      ? columnConfigData.columnWidth
      : undefined;

  return new ColumnConfig()
    .name(columnConfigData.fieldName)
    .visible(columnConfigData.visible)
    .wordWrap(columnConfigData.wordWrap)
    .width(width);
}

export default {
  deserializeColumnConfig,
};
